export default __webpack_public_path__ + "static/media/Ashok Baddi.29810609.jpg";